module.exports = __webpack_public_path__ + "static/media/logo.d42c2f3f.svg";